module.exports = __webpack_public_path__ + "img/SketchPng9dbba2e41212412831aee2a874ecc9e8c3f66db06edf9c2c932835ed9a3d7931.811f566a.png";